var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mpv-tooltip"},[_c('div',{class:_vm.noHover ? '' : 'mpv-tooltip-content'},[_vm._t("default")],2),_vm._v(" "),_c('div',{class:[
         'mpv-tooltip-text',
         _vm.short && _vm.position !== 'left' ? 'mpv-tooltip-text-short' : '',
         _vm.position === 'left' ? 'mpv-tooltip-text-left' : '',
         _vm.position === 'right' ? 'mpv-tooltip-text-right' : '',
         _vm.noClose ? 'mpv-tooltip-text-noClose' : '',
         _vm.active ? 'mpv-tooltip-active' : '',
         _vm.gray ? 'mpv-tooltip-text-gray' : '',
         _vm.noTip ? 'mpv-tooltip-text-noTip' : ''
       ],on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(!_vm.noClose)?_c('font-awesome-icon',{staticClass:"mpv-tooltip-close-icon",attrs:{"icon":[ 'fas', 'times' ]}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c9f403a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Tooltip.vue
// module id = null
// module chunks = 